import { TrendingUp, TrendingDown, Wallet, Clock } from 'lucide-react';
import type {
    FinancialStats,
    ChartDataPoint,
    School,
    Transaction,
    BankAccount,
    Account,
    Deposit,
    Transfer,
    Staff,
    Student
} from '../types';

// SMK Students Data
export const smkStudents: Student[] = [
    {
        id: 'SMK001',
        name: 'Budi Darmawan',
        parentName: 'Susi Susanti',
        class: 'Kelas 10 Multimedia',
        status: 'active',
        tuitionStatus: 'paid',
        totalBill: 'Rp 2.500.000',
        receivable: 'Rp 0',
        schoolId: 'smk-pusat',
        paymentHistory: [
            { id: 'PH_SMK_01', date: '2025-02-01', amount: 'Rp 1.250.000', method: 'Transfer', status: 'success', receiptNo: 'INV/SMK/001' },
            { id: 'PH_SMK_02', date: '2025-01-01', amount: 'Rp 1.250.000', method: 'Transfer', status: 'success', receiptNo: 'INV/SMK/002' },
        ]
    },
    {
        id: 'SMK002',
        name: 'Ani Yudhoyono',
        parentName: 'SBY',
        class: 'Kelas 11 TKJ',
        status: 'active',
        tuitionStatus: 'overdue',
        totalBill: 'Rp 5.000.000',
        receivable: 'Rp 5.000.000',
        amount: 'Rp 5.000.000',
        schoolId: 'smk-pusat',
        paymentHistory: []
    },
];

// SMK Sub-Schools List
export const smkSchools: School[] = [
    {
        id: 'smk-pusat',
        name: 'SMK Al-Azhar Pusat Pekanbaru',
        income: '620.4 Jt',
        expense: '210.6 Jt',
        balance: '409.8 Jt',
        receivable: '18.9 Jt',
        color: 'bg-info-soft text-info',
        icon: TrendingUp
    },
];

// SMK Unit Financial Statistics
export const smkStats: FinancialStats[] = [
    {
        label: 'Pendapatan Unit',
        value: 'Rp 620.400.000',
        change: '+14.2%',
        icon: TrendingUp,
    },
    {
        label: 'Pengeluaran Unit',
        value: 'Rp 210.600.000',
        change: '+7.5%',
        icon: TrendingDown,
    },
    {
        label: 'Saldo Kas Unit',
        value: 'Rp 409.800.000',
        change: '+19.8%',
        icon: Wallet,
    },
    {
        label: 'Piutang Siswa',
        value: 'Rp 18.900.000',
        change: '-6.3%',
        icon: Clock,
    },
];

// SMK Bank Accounts
export const smkBankAccounts: BankAccount[] = [
    {
        id: 'BANK-SMK-001',
        bankName: 'Mandiri',
        accountNumber: '1122xxxx33',
        accountName: 'SMK Al-Azhar Unit Pusat',
        balance: 'Rp 300.000.000',
        type: 'Rekening Operasional',
        linkedAccount: '1-1100 (Bank Mandiri)',
        status: 'active',
    },
    {
        id: 'BANK-SMK-002',
        bankName: 'BNI',
        accountNumber: '4455xxxx66',
        accountName: 'SMK Al-Azhar Unit - Prakerin',
        balance: 'Rp 109.800.000',
        type: 'Rekening Khusus',
        linkedAccount: '1-1120 (Bank BNI)',
        status: 'active',
    },
];

// SMK Chart of Accounts
export const smkAccounts: Account[] = [
    {
        id: 'ACC-SMK-1000',
        code: '1-1000',
        name: 'Kas SMK',
        type: 'asset',
        balance: 'Rp 409.800.000',
    },
    {
        id: 'ACC-SMK-4000',
        code: '4-1000',
        name: 'Pendapatan SPP SMK',
        type: 'income',
        balance: 'Rp 550.000.000',
    },
    {
        id: 'ACC-SMK-5000',
        code: '5-1000',
        name: 'Gaji Guru Produktif',
        type: 'expense',
        balance: 'Rp 140.000.000',
    },
];

// SMK Transactions
export const smkTransactions: Transaction[] = [
    {
        id: 'TRX-SMK-001',
        type: 'income',
        description: 'Pembayaran SPP Februari - SMK',
        amount: 'Rp 85.000.000',
        date: '2025-02-01',
        category: 'SPP',
    },
    {
        id: 'TRX-SMK-002',
        type: 'expense',
        description: 'Pembelian Peralatan Laboratorium Komputer',
        amount: 'Rp 15.500.000',
        date: '2025-01-29',
        category: 'Sarana Prasarana',
    },
];

// SMK Deposits
export const smkDeposits: Deposit[] = [
    {
        id: 'DEP-SMK-001',
        date: '2025-02-01',
        type: 'masuk',
        amount: 'Rp 85.000.000',
        description: 'Setoran Tunai SPP SMK',
        bankAccountId: 'BANK-SMK-001',
        status: 'completed',
    },
];

// SMK Transfers
export const smkTransfers: Transfer[] = [
    {
        id: 'TRF-SMK-001',
        date: '2025-01-15',
        fromUnit: 'SMK',
        toUnit: 'Pusat',
        amount: 'Rp 25.000.000',
        description: 'Setoran Dana Pengembangan Pusat',
        status: 'completed',
    },
];

// SMK Staff Data
export const smkStaff: Staff[] = [
    {
        id: 'STF-SMK-001',
        name: 'Ir. Ahmad Yani',
        position: 'Kepala Sekolah',
        department: 'Manajemen',
        status: 'active',
        schoolId: 'smk-pusat',
    },
    {
        id: 'STF-SMK-002',
        name: 'Ridwan Kamil, ST',
        position: 'Guru Produktif TKJ',
        department: 'Pengajaran',
        status: 'active',
        schoolId: 'smk-pusat',
    },
    {
        id: 'STF-SMK-003',
        name: 'Linda Wati, SE',
        position: 'Guru Akuntansi',
        department: 'Pengajaran',
        status: 'active',
        schoolId: 'smk-pusat',
    },
    {
        id: 'STF-SMK-004',
        name: 'Hadi Sucipto',
        position: 'Tenaga Bengkel',
        department: 'Sarana Prasarana',
        status: 'active',
        schoolId: 'smk-pusat',
    },
];

// SMK Chart Data (12 Months)
export const smkChartData: ChartDataPoint[] = [
    { month: 'Mar', income: 82000000, expense: 30000000 },
    { month: 'Apr', income: 85000000, expense: 31000000 },
    { month: 'Mei', income: 92000000, expense: 34000000 },
    { month: 'Jun', income: 80000000, expense: 38000000 },
    { month: 'Jul', income: 105000000, expense: 35000000 },
    { month: 'Agu', income: 98000000, expense: 33000000 },
    { month: 'Sep', income: 94000000, expense: 33000000 },
    { month: 'Okt', income: 98000000, expense: 35500000 },
    { month: 'Nov', income: 92000000, expense: 32200000 },
    { month: 'Des', income: 106000000, expense: 38000000 },
    { month: 'Jan', income: 99000000, expense: 34800000 },
    { month: 'Feb', income: 131400000, expense: 37100000 },
];
